import { AbstractControl, FormGroup } from '@angular/forms';
import { AttachmentTypeEnum } from '@models/enums/attachment-type-enum';
import { ContactTypeEnum } from '@models/enums/contact-type-enum';
import { normalizeUserFormApiLabel } from './user-form-api-error-labels.util';
import { findDocumentControlByApiLabel } from './user-form-document-api-error.util';
import { UserFormForApiErrors } from './user-form-api-error.types';

export function findUserFormControlByApiLabel(
  form: UserFormForApiErrors,
  apiLabel: string,
  errorMessage?: string,
): AbstractControl | null {
  const normalizedLabel = normalizeUserFormApiLabel(apiLabel);

  const staticGroups: FormGroup[] = [
    form.basicData,
    form.address,
    form.termoUsoForm,
    form.contaBancariaForm,
  ];

  for (const group of staticGroups) {
    if (group.contains(normalizedLabel)) {
      return group.get(normalizedLabel);
    }
  }

  if (normalizedLabel === 'ageTxCodigo' || normalizedLabel === 'ageNrId') {
    return form.contaBancariaForm.get('ageNrId');
  }

  if (normalizedLabel === 'BANCO' || normalizedLabel === 'banNrId') {
    return form.contaBancariaForm.get('banNrId');
  }

  const documentControl = findDocumentControlByApiLabel(
    form.documents,
    normalizedLabel,
    errorMessage,
  );
  if (documentControl) {
    return documentControl;
  }

  if (
    normalizedLabel === 'docTxDocumento' ||
    normalizedLabel === 'docTxOrgaoExpeditor'
  ) {
    return null;
  }

  const contactControl = findContactControlByApiLabel(form, normalizedLabel);
  if (contactControl) {
    return contactControl;
  }

  const attachmentControl = findAttachmentControlByApiLabel(
    form,
    normalizedLabel,
  );
  if (attachmentControl) {
    return attachmentControl;
  }

  for (const fg of form.responsibles.controls) {
    if (fg.contains(normalizedLabel)) {
      return fg.get(normalizedLabel);
    }
  }

  for (const fg of form.documents.controls) {
    if (fg.contains(normalizedLabel)) {
      return fg.get(normalizedLabel);
    }
  }

  for (const fg of form.contacts.controls) {
    if (fg.contains(normalizedLabel)) {
      return fg.get(normalizedLabel);
    }
  }

  for (const fg of form.attachments.controls) {
    if (fg.contains(normalizedLabel)) {
      return fg.get(normalizedLabel);
    }
  }

  return null;
}

function findContactControlByApiLabel(
  form: UserFormForApiErrors,
  apiLabel: string,
): AbstractControl | null {
  const contactTypes = Object.values(ContactTypeEnum) as string[];
  if (contactTypes.includes(apiLabel)) {
    const fg = form.contacts.controls.find(
      (c) => c.get('conTxTipo')?.value === apiLabel,
    );
    return fg?.get('conTxContato') ?? null;
  }

  return null;
}

function findAttachmentControlByApiLabel(
  form: UserFormForApiErrors,
  apiLabel: string,
): AbstractControl | null {
  const attachmentTypes = Object.values(AttachmentTypeEnum) as string[];
  if (attachmentTypes.includes(apiLabel)) {
    const fg = form.attachments.controls.find(
      (a) => a.get('aneTxTipoAnexo')?.value === apiLabel,
    );
    return fg?.get('aneBtAnexo') ?? null;
  }

  return null;
}
